import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        outline: 'text-foreground',
        nulo: 'border-transparent bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
        bajo: 'border-transparent bg-emerald-100 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-300',
        medio: 'border-transparent bg-amber-100 text-amber-800 dark:bg-amber-950/50 dark:text-amber-300',
        alto: 'border-transparent bg-orange-100 text-orange-800 dark:bg-orange-950/50 dark:text-orange-300',
        muyAlto: 'border-transparent bg-red-100 text-red-800 dark:bg-red-950/50 dark:text-red-300',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export function getRiskLevelVariant(level: string | undefined): BadgeProps['variant'] {
  const normalized = (level ?? '').toLowerCase().replace(/\s/g, '');
  if (normalized === 'nulo') return 'nulo';
  if (normalized === 'bajo') return 'bajo';
  if (normalized === 'medio') return 'medio';
  if (normalized === 'alto') return 'alto';
  if (normalized === 'muyalto') return 'muyAlto';
  return 'secondary';
}

export { Badge, badgeVariants };
